import { Path, Svg } from '../../svg';

/**
 * The "Generate notes" scroll glyph — lucide's `scroll-text` silhouette, but
 * FILLED. lucide ships stroke-only icons, so this one is drawn here: a blue
 * fill under the same outline, which is what distinguishes it from the two
 * plain glyphs beside it in `NotesGenerateRow`.
 *
 * The two colours are literal rather than theme-resolved, matching the deck
 * palette's `deck-blue-800` stroke over a `blue-400` fill. They are the values
 * this glyph has always shipped with on web; giving it a dark variant here
 * would make the two platforms differ, which is exactly what promoting the
 * icon into shared is meant to stop. Revisit with the dark-chrome work.
 */
export function ColoredScrollText({
  size = 18,
  className,
}: {
  size?: number;
  /** Forwarded to the svg — callers pass sizing / `shrink-0`. */
  className?: string;
}) {
  return (
    <Svg width={size} height={size} viewBox="0 0 18 18" fill="none" className={className}>
      <Path d="M11.25 9H7.5H11.25Z" fill={FILL} />
      <Path d="M11.25 6H7.5H11.25Z" fill={FILL} />
      <Path
        d="M14.25 12.75V3.75C14.25 3.35218 14.092 2.97064 13.8107 2.68934C13.5294 2.40804 13.1478 2.25 12.75 2.25H3"
        fill={FILL}
      />
      <Path
        d="M6 15.75H15C15.3978 15.75 15.7794 15.592 16.0607 15.3107C16.342 15.0294 16.5 14.6478 16.5 14.25V13.5C16.5 13.3011 16.421 13.1103 16.2803 12.9697C16.1397 12.829 15.9489 12.75 15.75 12.75H8.25C8.05109 12.75 7.86032 12.829 7.71967 12.9697C7.57902 13.1103 7.5 13.3011 7.5 13.5V14.25C7.5 14.6478 7.34196 15.0294 7.06066 15.3107C6.77936 15.592 6.39782 15.75 6 15.75C5.60218 15.75 5.22064 15.592 4.93934 15.3107C4.65804 15.0294 4.5 14.6478 4.5 14.25V3.75C4.5 3.35218 4.34196 2.97064 4.06066 2.68934C3.77936 2.40804 3.39782 2.25 3 2.25C2.60218 2.25 2.22064 2.40804 1.93934 2.68934C1.65804 2.97064 1.5 3.35218 1.5 3.75V5.25C1.5 5.44891 1.57902 5.63968 1.71967 5.78033C1.86032 5.92098 2.05109 6 2.25 6H4.5"
        fill={FILL}
      />
      <Path
        d="M14.25 12.75V3.75C14.25 3.35218 14.092 2.97064 13.8107 2.68934C13.5294 2.40804 13.1478 2.25 12.75 2.25H3C3.39782 2.25 3.77936 2.40804 4.06066 2.68934C4.34196 2.97064 4.5 3.35218 4.5 3.75V6V14.25C4.5 14.6478 4.65804 15.0294 4.93934 15.3107C5.22064 15.592 5.60218 15.75 6 15.75C6.39782 15.75 6.77936 15.592 7.06066 15.3107C7.34196 15.0294 7.5 14.6478 7.5 14.25V13.5C7.5 13.3011 7.57902 13.1103 7.71967 12.9697C7.86032 12.829 8.05109 12.75 8.25 12.75H14.25Z"
        fill={FILL}
      />
      <Path
        d="M11.25 9H7.5M11.25 6H7.5M3 2.25H12.75C13.1478 2.25 13.5294 2.40804 13.8107 2.68934C14.092 2.97064 14.25 3.35218 14.25 3.75V12.75H8.25M3 2.25C3.39782 2.25 3.77936 2.40804 4.06066 2.68934C4.34196 2.97064 4.5 3.35218 4.5 3.75M3 2.25C2.60218 2.25 2.22064 2.40804 1.93934 2.68934C1.65804 2.97064 1.5 3.35218 1.5 3.75V5.25C1.5 5.44891 1.57902 5.63968 1.71967 5.78033C1.86032 5.92098 2.05109 6 2.25 6H4.5M6 15.75H15C15.3978 15.75 15.7794 15.592 16.0607 15.3107C16.342 15.0294 16.5 14.6478 16.5 14.25V13.5C16.5 13.3011 16.421 13.1103 16.2803 12.9697C16.1397 12.829 15.9489 12.75 15.75 12.75H8.25M6 15.75C6.39782 15.75 6.77936 15.592 7.06066 15.3107C7.34196 15.0294 7.5 14.6478 7.5 14.25V13.5C7.5 13.3011 7.57902 13.1103 7.71967 12.9697C7.86032 12.829 8.05109 12.75 8.25 12.75M6 15.75C5.60218 15.75 5.22064 15.592 4.93934 15.3107C4.65804 15.0294 4.5 14.6478 4.5 14.25M4.5 14.25V3.75M4.5 14.25V6M4.5 3.75V6"
        stroke={STROKE}
        strokeWidth={1.67}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

const FILL = '#60A5FA';
const STROKE = '#193CB8';
